import React, { useEffect, useState } from "react";
import axios from "axios";
import { FiSave, FiEdit } from "react-icons/fi";

const ExtraContents = () => {
  const [contentData, setContentData] = useState({
    _id: "",
    topNavTitle: "",
  });
  const [initialContentData, setInitialContentData] = useState({
    _id: "",
    topNavTitle: "",
  });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [editing, setEditing] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        setLoading(true);
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}/extra-contents/get-all-contents`
        );
        if (data && data.length > 0) {
          setContentData({
            _id: data[0]._id,
            topNavTitle: data[0].topNavTitle,
          });
          setInitialContentData({
            _id: data[0]._id,
            topNavTitle: data[0].topNavTitle,
          });
        }
      } catch (err) {
        console.error(err);
        setMessage("Failed to fetch content.");
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      setSaving(true);
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}/extra-contents/create-content`,
        { topNavTitle: contentData.topNavTitle }
      );
      setMessage("Content updated successfully!");
      setTimeout(() => setMessage(null), 5000);
      setInitialContentData(contentData);
      setEditing(false);
    } catch (err) {
      setMessage(err.response?.data?.message || "Something went wrong.");
      setTimeout(() => setMessage(null), 5000);
    } finally {
      setSaving(false);
    }
  };

  const hasChanges =
    JSON.stringify(contentData) !== JSON.stringify(initialContentData);

  return (
    <div className="min-h-screen bg-transparent p-6 w-full">
      <h1 className="text-3xl font-heading font-bold mb-8 bg-gradient-to-r from-primaryBtnColor to-primaryBtnHoverColor bg-clip-text text-transparent inline-block">
        Manage Extra Content
      </h1>

      {loading ? (
        <div className="bg-white shadow-xl rounded-2xl p-6 space-y-6 animate-pulse">
          <div className="h-4 w-32 bg-gray-300 rounded mb-2"></div>
          <div className="h-10 w-full bg-gray-200 rounded"></div>
        </div>
      ) : (
        <form
          onSubmit={handleSave}
          className="bg-white rounded-2xl space-y-6 max-w-full"
        >
          {/* Top Navigation Title */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Top Navigation Title
            </label>
            <input
              type="text"
              value={contentData.topNavTitle}
              onChange={(e) =>
                setContentData({ ...contentData, topNavTitle: e.target.value })
              }
              className="w-full px-4 py-2 border border-black rounded-lg outline-none focus:ring-1 focus:ring-black"
              placeholder="Enter top navigation title (e.g., UPCOMING EVENT OR SOME INFORMATION SHOWN HERE)"
              required
              disabled={!editing}
            />
            <p className="text-xs text-gray-500 mt-1">
              This text will be displayed at the top of the navigation bar
            </p>
          </div>

          {/* Buttons */}
          <div
            className={`w-full flex items-center ${
              message ? "justify-between" : "justify-end"
            } gap-4`}
          >
            {message && (
              <p
                className={`text-sm font-medium ${
                  message.includes("success")
                    ? "text-green-600"
                    : "text-red-600"
                }`}
              >
                {message}
              </p>
            )}
            {!editing ? (
              <button
                type="button"
                onClick={() => setEditing(true)}
                className="w-52 px-6 py-2 rounded-xl shadow-md font-medium 
                 text-gray-800 bg-gradient-to-r from-gray-100 to-gray-300
                 hover:from-gray-200 hover:to-gray-400 
                 active:scale-95 transition-all duration-200 ease-in-out
                 flex items-center justify-center gap-2"
              >
                <FiEdit className="text-lg text-gray-600" />
                Edit Content
              </button>
            ) : (
              <button
                type="submit"
                disabled={saving || !hasChanges}
                className="flex items-center justify-center w-52 gap-2 bg-gradient-to-r from-primaryBtnColor to-primaryBtnHoverColor text-white px-6 py-2 rounded-lg shadow-lg hover:opacity-90 transition disabled:opacity-50"
              >
                {saving ? (
                  <div className="spinner w-full"></div>
                ) : (
                  <>
                    <FiSave size={18} />
                    Save Changes
                  </>
                )}
              </button>
            )}
          </div>
        </form>
      )}
    </div>
  );
};

export default ExtraContents;
